import React from 'react';
import DrawerMenu from './DrawerMenu';

const Layout = ({ children }) => {
  return <DrawerMenu>{children}</DrawerMenu>;
};

export default Layout;
